<template>
    <grid-layout class="p-3 md:p-6 -my-3 md:-my-6">
        <grid-layout-item
            v-for="file in files"
            :key="file.uuid"
            class="mt-3 md:mt-6 w-1/2 md:w-1/3"
        >
            <file-card :file="file" />
        </grid-layout-item>
    </grid-layout>
</template>

<script>
    import FileCard from './file-card'

    export default {
        components: {
            FileCard
        },
        props: {
            files: {
                type: Array,
                required: true
            }
        }
    }
</script>
